import {query} from "@/graphql/client";
import {graphql} from "@/graphql/generated";
import {ShiftTimes} from "@/graphql/generated/graphql";


export async function fetchGlobalShiftHullTimes(): Promise<ShiftTimes[]> {
    const result = await query(
        graphql(`query GetGlobalHullTimes{
            globalHullTimes{
                begin
                until
                type
            }
        }
        `)
    )

    return result?.data?.globalHullTimes
}

export async function fetchGlobalShiftCoreTimes(): Promise<any> {
    const result = await query(
        graphql(`query GetGlobalCoreTimes{
            globalCoreTimes {
                begin
                until
                type
            }
        }
        `)
    )

    return result?.data?.globalCoreTimes
}

export const AVERAGE_SHIFT_DURATION = 7.7
